import React from "react";
import moment from "moment";
import PropTypes from "prop-types";
import connect from 'react-redux/lib/connect/connect';
import bindActionCreators from 'redux/lib/bindActionCreators';

import StorageGateway from "lib/storage-gateway";
import Button from 'reactstrap/lib/Button';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';
import { UncontrolledTooltip } from "reactstrap";
import { buildDepartmentAndTeamOptions } from "helpers/utils";
import * as BasicSettingDucks from "ducks/vendors/basicSetting";
import * as ReportDucks from "ducks/reports/report";
import * as UserDucks from "ducks/accounts/user";
import * as DepartmentDucks from "ducks/vendors/department";
import * as TeamDucks from "ducks/vendors/team";
import * as RouteDucks from 'ducks/routes';
import ButtonLoaderAtom from "atoms/ButtonLoader";
import queryString from "query-string";
import FilterDropdownComponent from "components/common/FilterDropdown";
import styles from "./styles.module.scss";
import { REPORT_KEY_MAPPINGS } from "constants/reports";
class FLSAReportFilterSection extends React.Component {
  constructor(props) {
    super(props);
    this.export = this.export.bind(this);
    this.state = { isLoading: false };
  }

  getYearOptions = () => {
    const currentYear = moment().year();
    const years = [{ value: "", label: "Select Year" }];

    for (let y = currentYear; y >= 2000; y--) {
      years.push({
        value: y.toString(),
        label: y.toString(),
      });
    }

    return years;
  };

  export() {
    const {
      router: {
        route: {
          match: { params },
        },
      },
    } = this.context;
    const {
      location: { query },
    } = this.props;
    this.setState({ isLoading: true });
    const companyId = StorageGateway.get("company_id");
    params.company_id = companyId;

    return this.props.ReportDucks.exportFlsaReport({
      ...query,
      ...params,
      is_export: true,
    })
      .then((data) => {
        // Get the actual binary data from the response
        const binaryData = data.action.payload;

        // Verify we have data
        if (!binaryData || binaryData.byteLength === 0) {
          this.setState({ isLoading: false });
          return;
        }

        // Create filename with proper date format
        const date = moment().format("DD-MM-YYYY");
        const fileName = `${REPORT_KEY_MAPPINGS[params.code]}-${date}.xlsx`;

        // Create blob with correct MIME type
        const myBlob = new Blob([binaryData], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Only for IE 11
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(myBlob, fileName);
        }
        // Modern browsers (Chrome, Firefox, Safari, Edge)
        else {
          const url = window.URL.createObjectURL(myBlob);
          const element = document.createElement("a");
          element.href = url;
          element.download = fileName;
          element.style.display = "none";

          // Append to body, click, and clean up
          document.body.appendChild(element);
          element.click();

          // Clean up after a short delay
          setTimeout(() => {
            document.body.removeChild(element);
            window.URL.revokeObjectURL(url);
          }, 100);
        }

        this.setState({ isLoading: false });
      })
      .catch((error) => {
        console.error("Export failed:", error);
        this.setState({ isLoading: false });
      });
  }

  render() {
    const {
      location,
      departmentAll,
      userExtraData,
      teamAll,
      onDepartmentSelect,
    } = this.props;
    const { query } = location;
    const formattedDates = {};
    const { isLoading } = this.state;

    if (query.start_date)
      formattedDates.start_date = moment(query.start_date).toISOString();
    if (query.end_date)
      formattedDates.end_date = moment(query.end_date).toISOString();
    const { departmentOptions, teamOptions } = buildDepartmentAndTeamOptions({
      departmentAll,
      teamAll,
      userExtraData,
    });

    return (
      <Row className="report-filter ml-3 mr-4">
        <Col md={10} className="px-0">
          <section className={styles["custom-filter"]}>
            {departmentOptions.length > 0 && (
              <div
                id="department"
                className="d-inline-block department-index department-dropdown reportdropdown reportdropdown-override"
              >
                <FilterDropdownComponent
                  paramKey="department_id"
                  location={location}
                  options={departmentOptions}
                  onChange={(val) => onDepartmentSelect(val)}
                />
                <UncontrolledTooltip placement="top" target="department">
                  Select Department
                </UncontrolledTooltip>
              </div>
            )}
            {teamOptions.length > 0 && (
              <div
                id="team"
                className="d-inline-block department-dropdown reportdropdown reportdropdown-override"
              >
                <FilterDropdownComponent
                  paramKey="team_id"
                  location={location}
                  options={teamOptions}
                />
                <UncontrolledTooltip placement="top" target="team">
                  Select Team
                </UncontrolledTooltip>
              </div>
            )}
          </section>
          <div
            id="year"
            className="d-inline-block department-dropdown reportdropdown reportdropdown-override"
          >
            <FilterDropdownComponent
              paramKey="year"
              options={this.getYearOptions()}
              location={location}
               onChange={(year) => {
                const start_date = moment(`${year}-01-01`).format("YYYY-MM-DD");
                const end_date = moment(`${year}-12-31`).format("YYYY-MM-DD");
                this.context.router.history.push({
                  pathname: this.props.location.pathname,
                  search: queryString.stringify({
                    ...this.props.query,
                    year,
                    start_date,
                    end_date,
                  }),
                });
              }}
            />
            <UncontrolledTooltip placement="top" target="year">
              Select Year
            </UncontrolledTooltip>
          </div>
        </Col>
        <Col md={2} className="px-0">
          {Object.keys(query).length > 0 && query.start_date && (
            <section className="float-right">
              <Button color="accent" className="mr-0" onClick={this.export}>
                Export <ButtonLoaderAtom active={isLoading} />
              </Button>
            </section>
          )}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  dateFormat: BasicSettingDucks.dateFormat(state),
  location: RouteDucks.location(state),
  userCompany: UserDucks.userCompany(state),
  departmentAll: DepartmentDucks.departmentAll(state),
  userExtraData: UserDucks.userExtraData(state),
  teamAll: TeamDucks.teamAll(state),
});

const mapActionsToProps = (dispatch) => ({
  ReportDucks: bindActionCreators(ReportDucks, dispatch),
});

FLSAReportFilterSection.propTypes = {
  dateFormat: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  userCompany: PropTypes.object.isRequired,
};

FLSAReportFilterSection.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(FLSAReportFilterSection);
